const MAX_OAUTH_POPUP_HANDLES = 5;
const oauthPopupHandles = new Set<Window>();
let consumedOAuthPopupSources = new WeakSet<Window>();

export const setOAuthPopupHandle = (handle: Window | null): void => {
  if (!handle) {
    return;
  }

  consumedOAuthPopupSources.delete(handle);
  oauthPopupHandles.delete(handle);
  oauthPopupHandles.add(handle);
  if (oauthPopupHandles.size > MAX_OAUTH_POPUP_HANDLES) {
    const oldest = oauthPopupHandles.values().next().value;
    if (oldest) {
      oauthPopupHandles.delete(oldest);
    }
  }
};

export const getOAuthPopupHandle = (): Window | null => Array.from(oauthPopupHandles).pop() ?? null;

export const getOAuthPopupHandleCount = (): number => oauthPopupHandles.size;

export const isOAuthPopupSource = (source: MessageEventSource | null): boolean =>
  source !== null && oauthPopupHandles.has(source as Window);

export const consumeOAuthPopupSource = (source: MessageEventSource | null): boolean => {
  if (!isOAuthPopupSource(source)) {
    return false;
  }
  consumedOAuthPopupSources.add(source as Window);
  return oauthPopupHandles.delete(source as Window);
};

export const wasOAuthPopupSourceConsumed = (source: MessageEventSource | null): boolean =>
  source !== null && consumedOAuthPopupSources.has(source as Window);

export const clearOAuthPopupHandles = (): void => {
  // WeakSet has no clear(); reassignment is the only way to drop every consumed marker.
  consumedOAuthPopupSources = new WeakSet<Window>();
  oauthPopupHandles.clear();
};
